<div class="preview" *ngIf="isPreviewEnabled">
    preview
</div>